export const PROCESS_START = 'process/process-start';
export const PROCESS_SUCCESS = 'process/process-success';
export const PROCESS_ERROR = 'process/process-error';
